var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organizations !== null)?_c('v-row',[_vm._l((_vm.organizations),function(organization){return [_c('v-col',{key:organization.uuid,attrs:{"cols":"12","lg":"4","md":"4","sm":"6","xl":"4"}},[_c('OrganizationCard',{attrs:{"organization":organization}})],1)]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }